import Error from './Error';
import Warning from './Warning';

const Animation = {
  Error,
  Warning,
};

export default Animation;
